function normalizePrivileges(privileges) {

    if (privileges === undefined || privileges === null)
        return [];
    if (Array.isArray(privileges))
        return privileges;
    return [privileges];

}

function createServiceFactoryDataManager() {

    if (!this.serviceFactoryDataManager)
        this.serviceFactoryDataManager = this.getServiceFactory().createServiceDataManager(this.getDataModel());
    return this.serviceFactoryDataManager;

}

function unionPrivileges(...privilegesGroups) {

    const uniquePrivileges = new Map();

    privilegesGroups
        .flatMap((privileges) => normalizePrivileges(privileges))
        .forEach((privilegeExpression) => {
            const key = JSON.stringify(privilegeExpression);
            if (!uniquePrivileges.has(key))
                uniquePrivileges.set(key, privilegeExpression);
        });

    return Array.from(uniquePrivileges.values());

}

export function preprocessGeneratedRoutes(routeDefs) {

    if (!Array.isArray(routeDefs))
        throw new Error('[generated-artifacts-preprocessor] "routeDefs" must be an array.');

    return routeDefs.map((routeDef) => {
        const options = Object.assign({}, routeDef?.options ?? {});

        if (!Object.hasOwn(options, 'dataManager'))
            options.dataManager = createServiceFactoryDataManager;

        return Object.assign({}, routeDef, {
            public: routeDef?.public === true,
            options,
            privileges: normalizePrivileges(routeDef?.public === true ? [] : routeDef?.privileges),
        });
    });

}

export function preprocessGeneratedMenuItems(menuDefs, routeDefs) {

    if (!Array.isArray(menuDefs))
        throw new Error('[generated-artifacts-preprocessor] "menuDefs" must be an array.');
    if (!Array.isArray(routeDefs))
        throw new Error('[generated-artifacts-preprocessor] "routeDefs" must be an array.');

    const routesByName = new Map(routeDefs.map((routeDef) => [routeDef.name, routeDef]));

    return preprocessMenuItems(menuDefs, routeDefs, {
        errorPrefix: '[generated-artifacts-preprocessor]',
        routesByName,
    });

}

export function preprocessManualMenuItems(menuDefs, routeDefs) {

    if (!Array.isArray(menuDefs))
        throw new Error('[generated-artifacts-preprocessor] "menuDefs" must be an array.');
    if (!Array.isArray(routeDefs))
        throw new Error('[generated-artifacts-preprocessor] "routeDefs" must be an array.');

    const routesByName = new Map(routeDefs.map((routeDef) => [routeDef.name, routeDef]));

    return preprocessMenuItems(menuDefs, routeDefs, {
        errorPrefix: '[generated-artifacts-preprocessor]',
        routesByName,
    });

}

function preprocessMenuItems(menuDefs, routeDefs, { errorPrefix, routesByName }) {

    return menuDefs.map((menuDef) => {
        const routeNames = Array.isArray(menuDef?.routes) ? menuDef.routes : [];

        if (routeNames.length === 0)
            return Object.assign({}, menuDef);

        const referencedRoutes = routeNames.map((routeName) => {
            const routeDef = routesByName.get(routeName) ?? null;

            if (!routeDef)
                throw new Error(`${errorPrefix} Menu item "${menuDef?.name ?? '?'}" references unknown route "${routeName}".`);

            return routeDef;
        });

        const processedMenuDef = Object.assign({}, menuDef, {
            public: referencedRoutes.some((routeDef) => routeDef.public === true),
        });

        if (!Object.hasOwn(processedMenuDef, 'privileges')) {
            const inheritedPrivileges = unionPrivileges(
                ...referencedRoutes.map((routeDef) => routeDef.privileges)
            );

            if (inheritedPrivileges.length > 0) {
                processedMenuDef.privileges = inheritedPrivileges;
            } else {
                delete processedMenuDef.privileges;
            }
        }

        return processedMenuDef;
    });

}
